import { useState } from "react";
import { getPresentationParamsForOrigin } from "../../../getPresentationParamsForOrigin.ts";
import { useCommand } from "../../../hooks/useCommand.ts";
import { CompetitionCommand } from "../../../commandTypes.ts";
import { useCompetitionList } from "../../../hooks/useCompetitionList.ts";
import { Box, Divider, Loader, Select, Stack } from "@mantine/core";
import { Page } from "../../../Components/Page.tsx";
import { useCompetition } from "../../../hooks/useCompetition.ts";
import { TeamSponsor } from "./TeamSponsor.tsx";

export const AdOverview = () => {
  const [competitionId, setCompetitionId] = useState<string>(
    getPresentationParamsForOrigin().competitionId,
  );
  useCommand<CompetitionCommand>("competition", (c) => {
    setCompetitionId(c.competitionId);
  });

  const competitionData = useCompetitionList();
  const competition = useCompetition(competitionId);

  if (!competitionData.isSuccess) {
    return <Loader />;
  }

  return (
    <Page title="Werbung">
      <Select
        my="md"
        label="Turnier"
        value={competitionId}
        onChange={(v) => {
          if (!v) {
            return;
          }
          setCompetitionId(v);
        }}
        data={competitionData.data.competitions.map((c) => ({
          value: c.id,
          label: c.name,
        }))}
      />

      {competition.isSuccess && (
        <Stack gap="xl">
          {competition.data.teamIds.map((t) => {
            return (
              <>
                <Box key={t}>
                  <TeamSponsor teamId={t} />
                </Box>
                <Divider />
              </>
            );
          })}
        </Stack>
      )}
    </Page>
  );
};
